import { colors, fontSize, fontWeight, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  qaCard: css({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.white,
    maxWidth: 670,
    margin: 'auto',
    justifyContent: 'space-between',
    color: '#131F4A',
    fontSize: 18,
    fontWeight: fontWeight.semiBold,
    lineHeight: '120%',
    borderRadius: 10,
    border: '3px solid #e4ebef',
    marginBottom: 12,
  }),

  heading: css({
    color: '#131F4A',
    fontSize: 32,
    lineHeight: '145%',
    fontWeight: fontWeight.bold,
    margin: 0,
  }),

  question: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    padding: spacing.large,
    '-webkit-tap-highlight-color': 'transparent',
  }),

  arrow: css({
    display: 'flex',
    marginLeft: 'auto',
    width: 40,
    height: 40,
    transition: '250ms',
    transformStyle: 'preserve-3d',
    transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
  }),

  rotateArrow: css({
    img: {
      transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(180deg) skew(0deg, 0deg)',
    },
  }),

  answer: css({
    fontSize: fontSize.default,
    lineHeight: '150%',
    fontWeight: fontWeight.regular,
    padding: spacing.large,
    paddingTop: 0,

    p: {
      margin: 0,
    },
  }),
}

export default styles
